import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { StatusBannerReducerType } from 'redux/reducers/internal/StatusBanner'

export const selectInternalStatusBanners = createSelector(
  [
    (state: ApplicationState): StatusBannerReducerType =>
      state.InternalStatusBannerStore
  ],
  (store) => store
)
